import React, {useMemo} from "react";
import {ListboxOption} from "headlessui-v2";
import {ProductSelectionOption} from "@/data/entities/cart";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";
import RadioCheckIndicator from "./RadioCheckIndicator";
import DepositIndicator from "@widgets/pos/order/menu/product/options/option/DepositIndicator";
import SoldOutBadge from "@widgets/pos/order/menu/product/options/option/SoldOutBadge";
import PriceIndicator from "@widgets/pos/order/menu/product/options/option/PriceIndicator";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

type Props = {
    option: ProductSelectionOption,
    canSelectMultiple: boolean,
};

const ProductOptionListItem = ({option, canSelectMultiple}: Props) => {
    const fulfillmentType = useFulfillmentType();
    const isAvailable: boolean = useMemo(
        () => option.availability.includes(fulfillmentType.toLowerCase()),
        [option.availability, fulfillmentType]);

    return (
        <ListboxOption
            key={option.optionExternalId}
            value={option}
            disabled={option.soldout || !isAvailable}
            className={"group/item transition-colors duration-150 data-[focus]:bg-gray-100 data-[disabled]:bg-gray-50 dark:data-[focus]:bg-slate-700 dark:data-[disabled]:bg-slate-600 px-4 py-1.5 sm:py-2 gap-4 w-full cursor-pointer data-[disabled]:cursor-not-allowed flex flex-row items-center text-sm"}
        >
            {({selected}) => (
                <>
                    <RadioCheckIndicator
                        canSelectMultiple={canSelectMultiple}
                        selected={selected}
                    />

                    <div className={"w-full flex flex-row gap-3 items-center justify-between"}>
                        <div className={"flex flex-row flex-wrap items-center justify-start gap-3"}>
                            <strong className={"font-medium text-black dark:text-white group-data-[disabled]/item:text-gray-500"}>
                                {option.optionName}
                            </strong>

                            <DepositIndicator
                                option={option}
                                isAvailable={isAvailable}
                            />
                        </div>

                        {
                            option.soldout
                                ? <SoldOutBadge/>
                                : (isAvailable
                                        ? <PriceIndicator option={option}/>
                                        : (
                                            <Badge color={"secondary"}>
                                                <FormattedMessage id={`unavailable-for-${fulfillmentType}`}/>
                                            </Badge>
                                        )
                                )
                        }
                    </div>
                </>
            )}
        </ListboxOption>
    );
};

export default ProductOptionListItem;